import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import BgMaxPrice from './BgMaxPrice';
import ErrorResponse from './ErrorResponse';
import mapBgMaxPrice from './mapBgMaxPrice';
import ProductUpdate from './ProductUpdate';

export interface Result {
	bgMaxPrice: BgMaxPrice;
}

export const updateBgMaxPrice = async (
	client: ApiClient,
	userId: string,
	groupId: string,
	referenceBasketVersion: string,
	packageSize: number | null,
	historicProductDataViewDate: Date | null,
	products: ProductUpdate[]
): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/bg-max-price');

	try {
		const request = await client.fetch(url.expand({ userId, groupId }), {
			body: JSON.stringify({
				products: products.map((product) => ({
					id: product.id,
					packageSizeForCalculation: product.packageSizeForCalculation,
					packageSizeForSingleUnit: product.packageSizeForSingleUnit,
					priceTypeForCalculation: product.priceTypeForCalculation,
					selected: product.selected,
				})),
				reference: {
					packageSize,
					referenceBasketVersion,
					historicProductDataViewDate:
						historicProductDataViewDate !== null ? formatApiDate(historicProductDataViewDate) : null,
				},
			}),
			method: 'POST',
		});
		const response = await request.json();
		return {
			bgMaxPrice: mapBgMaxPrice(response.bgMaxPrice),
		};
	} catch (error) {
		if (error instanceof ApiClientErrorResponse) {
			throw new ErrorResponse(error.request, error.statusCode, error.errors);
		}
		throw error;
	}
};
